module.exports = __webpack_public_path__ + "static/media/1-4-2.a9a6da56.png";